import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { TranslateService } from "@ngx-translate/core";

export class DIStatusHelper {
  constructor() {}

  getStatus(item: any, columnProperty: string): string {
    // return CubiqTS.OrderStatus[order[columnProperty]];
    let status: number = -1;
    let data = "";

    if (item && typeof item[columnProperty] === "number" && item[columnProperty] >= 0) {
      status = item[columnProperty];
    }
    if (status === CubiqTS.DIReason.ENTRY_CREDIT_FAIL) {
      data = "Credit (Entry)";
    } else if (
      status === CubiqTS.DIReason.CREDIT_CANCEL_FAIL ||
      status === CubiqTS.DIReason.CREDIT_EXPIRY_FAIL ||
      status === CubiqTS.DIReason.CREDIT_CANCEL_TIMEOUT ||
      status === CubiqTS.DIReason.CREDIT_EXPIRY_TIMEOUT
    ) {
      data = "Credit (Cancel/Expiry)";
    } else if (status === CubiqTS.DIReason.ENTRY_CREDIT_PROXIMITY_FAIL) {
      data = "Credit (Entry + Proximity)";
    } else if (status === CubiqTS.DIReason.MODIFY_CREDIT_FAIL) {
      data = "Credit (Modify)";
    } else if (status === CubiqTS.DIReason.MODIFY_CREDIT_PROXIMITY_FAIL) {
      data = "Credit (Modify + Proximity)";
    } else if (status === CubiqTS.DIReason.FILL_CREDIT_FAIL) {
      data = "Credit (Fill)";
    } else if (
      status === CubiqTS.DIReason.CREDIT_REJECT_FAIL ||
      status === CubiqTS.DIReason.CREDIT_REJECT_TIMEOUT
    ) {
      data = "Credit (Rejected)";
    } else if (status === CubiqTS.DIReason.DAILY_REVAL_CREDIT_FAIL) {
      data = "Credit (Daily)";
    } else if (status === CubiqTS.DIReason.PROXIMITY_REVAL_CREDIT_FAIL) {
      data = "Credit (Proximity)";
    } else if (status === CubiqTS.DIReason.FORCE_TO_DI) {
      data = "Force to DI";
    } else if (
      status === CubiqTS.DIReason.SOFT_CUT_OFF &&
      // SOFT_CUT_OFF is sometimes shared with a variety of acceptance states
      // parse these if they are available. -dc
      item != null &&
      item.orderData instanceof CubiqTS.OrderDataImpl
    ) {
      const orderData: CubiqTS.OrderDataImpl = item.orderData;
      const orderState = orderData.orderState;

      if (
        orderState === CubiqTS.OrderState.ACCEPTANCE_NEEDED &&
        (orderData.modifyInAcceptanceFg === true ||
          (orderData.lockType == null &&
            (orderData.lockUserId != null || orderData.siLockUserId != null)))
      ) {
        data = "Modify In";
      } else if (orderState === CubiqTS.OrderState.MODIFY_ACCEPTANCE_NEEDED) {
        data = "Modify Out";
      } else if (orderState === CubiqTS.OrderState.CANCEL_ACCEPTANCE_NEEDED) {
        data = "Cancel";
      } else {
        data = "Entry";
      }
    } else if (status === CubiqTS.DIReason.SOFT_CUT_OFF) {
      // no order data available fallback to generic 'Entry'
      data = "Entry";
    } else if (status === CubiqTS.DIReason.CANCEL_DURING_SOFT_CUT_OFF) {
      // CANCEL_DURING_SOFT_CUT_OFF is sometimes shared with a variety of acceptance states
      // TODO consider parsing order data if required -dc
      data = "Cancel";
    } else if (status === CubiqTS.DIReason.FIXING_RATE_REQUIREMENT) {
      data = "Fix Rates";
    } else if (status === CubiqTS.DIReason.FILL_NOT_RECEIVED) {
      data = "Fill Not Received";
    } else if (status === CubiqTS.DIReason.FILL_WITHELD) {
      data = "Fill Withheld";
    } else if (status === CubiqTS.DIReason.FILL_FWD_ROLL_NOT_RECEIVED) {
      data = "Forward Roll Not Received";
    } else if (status === CubiqTS.DIReason.PORTFOLIO_FWD_ROLL) {
      data = "Manual Roll Required";
    } else if (status === CubiqTS.DIReason.PORTFOLIO_FWD_ROLL_SAVED) {
      data = "Manual Roll Saved";
    } else if (status === CubiqTS.DIReason.PORTFOLIO_FWD_ROLL_AUTO_SAVED) {
      data = "Auto Roll Saved";
    } else if (status === CubiqTS.DIReason.PORTFOLIO_FWD_ROLL_ERROR) {
      data = "Auto Roll Failed";
    } else {
      data = "-";
    }

    return data;
  }

  retrieveSort(item: any, columnProperty: string): number {
    if (item && typeof item[columnProperty] === "number" && item[columnProperty] >= 0) {
      return item[columnProperty];
    }
    return -1;
  }
}
